import React from 'react';
import { useTranslation } from 'react-i18next';

const LoadingSpinner: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center min-h-[400px]" role="status" aria-label={t('common.loading')}>
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 border-4 border-primary-200 border-t-primary-500 rounded-full animate-spin" />
        <p className="text-neutral-500 text-sm">{t('common.loading')}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
